import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

export async function getAllGrids() {
    try {
        const response = await fetch(base + 'grid');
        return await response.json();
    } catch (error) {
        console.error('Erreur getAllGrids', error);
        throw error;
    }
}

export async function getGridById(id) {
    try {
        const response = await fetch(base + 'grid/' + id);
        return await response.json();
    } catch (error) {
        console.error('Erreur getGridById', error);
        throw error;
    }
}

/**
 * Créer un nouveau jeu
 */
export async function createGrid(name, description, steps, active, hasPlaces, hasHints, image = null) {
    try {
        const formData = new FormData();
        formData.append('nom', name);
        formData.append('description', description ?? '');
        formData.append('steps', steps.toString());
        formData.append('active', active ? '1' : '0');
        if (image) formData.append('image', image);

        const authToken = localStorage.getItem("authToken"); 
        const response = await fetch(base + "grid/insert", {
            method: 'POST',
            headers: { 
                'Authorization': `Bearer ${authToken}` 
            },
            body: formData
        });

        return await response.json();
    } catch (error) {
        console.error('Erreur createGrid:', error);
        throw error;
    }
} 


/**
 * Activer/désactiver un jeu
 */
export async function toggleGrid(id, isActive) {
    try {
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(base + "grid/toggle", {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({ id, toggle: isActive })
        });

        return await response.json();
    } catch (error) {
        console.error('Erreur toggleGrid:', error);
        throw error;
    }
}

/**
* Modifier le nom
*/
export async function updateGridName(id, name) {
   try {
       const authToken = localStorage.getItem("authToken"); 
       const response = await fetch(base + "grid/update-name", {
           method: 'POST',
           credentials: "include",
           headers: { 
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${authToken}` 
           },
           body: JSON.stringify({ id, nom: name })
       });
       return await response.json();
   } catch (error) {
       console.error('Erreur updateGridName:', error);
       throw error;
   }
}

/**
* Modifier la description
*/
export async function updateGridDescription(id, description) {
   try {
       const authToken = localStorage.getItem("authToken"); 
       const response = await fetch(base + "grid/update-description", {
           method: 'POST',
           credentials: "include",
           headers: { 
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${authToken}` 
           },
           body: JSON.stringify({ id, description })
       });
       return await response.json();
   } catch (error) {
       console.error('Erreur updateGridDescription:', error);
       throw error;
   }
}

/**
* Modifier le nombre d'étapes
*/
export async function updateGridSteps(id, steps) {
   try {
       const authToken = localStorage.getItem("authToken"); 
       const response = await fetch(base + "grid/update-steps", {
           method: 'POST',
           credentials: "include",
           headers: { 
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${authToken}` 
           },
           body: JSON.stringify({ id, steps })
       });
       return await response.json();
   } catch (error) {
       console.error('Erreur updateGameSteps:', error);
       throw error;
   }
}

/**
 * Modifier l'image
 */
export async function updateGridImage(id, image) {
    try {
        const formData = new FormData();
        formData.append('id', id);
        formData.append('image', image);

        const authToken = localStorage.getItem("authToken"); 
        const response = await fetch(base + "grid/update-image", {
        method: 'POST',
        headers: { 
            'Authorization': `Bearer ${authToken}` 
        },
        body: formData
        });

        return await response.json();
    } catch (error) {
        console.error('Erreur updateGameImage:', error);
        throw error;
    }
}

/**
 * Supprimer l'image
 */
export async function deleteGridImage(id, image) {
    try {
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(base + "grid/delete-image", {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({ id, image })
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur deleteGridImage:', error);
        throw error;
    }
}

/**
 * Supprimer un jeu (via POST)
 */
export async function deleteGame(id) {
    try {
        const authToken = localStorage.getItem("authToken"); 
        const response = await fetch(base + "grid/delete", {
        method: 'POST',
        headers: { 
            'Authorization': `Bearer ${authToken}` 
        },
        body: JSON.stringify({ id })
        });

        return await response.json();
    } catch (error) {
        console.error('Erreur deleteGame:', error);
        throw error;
    }
}

/**
 * Récupérer le dernier jeu inséré
 */
export async function getLastInsertedGame() {
    try {
        // const authToken = localStorage.getItem("authToken");
        const response = await fetch(base + "grid/last", {
            method: 'GET',
            // credentials: "include",
            // headers: {
            //     'Authorization': `Bearer ${authToken}`
            // }
        });

        if (!response.ok) {
            const message = await response.text();
            throw new Error(`Erreur API ${response.status} : ${message}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Erreur getLastInsertedGame:', error);
        throw error;
    }
}

/**
 * Activer/désactiver hasPlaces
 */
export async function toggleGridPlaces(id, places) {
    try {
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(base + "grid/toggle-places", {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({ id, places })
        });

        return await response.json();
    } catch (error) {
        console.error('Erreur toggleGridPlaces:', error);
        throw error;
    }
}

/**
 * Activer/désactiver hasHints
 */
export async function toggleGridHints(id, hints) {
    try {
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(base + "grid/toggle-hints", {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({ id, hints })
        });

        return await response.json();
    } catch (error) {
        console.error('Erreur toggleGridHints:', error);
        throw error;
    }
}
